import { useAppSelector } from '@app/redux/hooks';

export const useFeatureAccess = () => {
  const businessId = useAppSelector((state) => state.business.selected?.id);
  const subscriptions = useAppSelector((state) => state.auth.user?.subscriptions);

  const subscription = subscriptions?.find((s) => s.businessId === businessId);
  const now = Math.floor(Date.now() / 1000);
  const isTrial =
    subscription?.trialEnd !== undefined &&
    subscription.trialEnd !== null &&
    subscription.trialEnd > now;

  return {
    aiEnabled: subscription?.aiEnabled || false,
    automationEnabled: subscription?.automationEnabled || false,
    messagingEnabled: subscription?.messagingEnabled || false,
    reviewRequestLimit: subscription?.reviewRequestLimit || 0,
    seatLimit: subscription?.seatLimit || 1,
    spentRequests: subscription?.spentRequests || 0,
    spentSeats: subscription?.spentSeats || 1,
    isTrial,
  };
};
